import { Spinner as ChackraSpinner, Box } from "@chakra-ui/react";

function Spinner() {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="100vh"
    >
      <ChackraSpinner
        thickness="5px"
        speed="0.65s"
        emptyColor="gray.200"
        color="#739691"
        size="xl"
      />
    </Box>
  );
}

export default Spinner;